<template>
  <div>
    <div class="mrB20" />
    <div class="comm_shut_wrap">
      <div class="inbox">
        <sui-grid
          ref="grid"
          :columns="gridColumns0"
          :dataset="'dsAction'"
          :multiselect="true"
          :showDisplayCountControl="false"
        >
          <div class="comp_spacing" />
          <div class="btn_wrapL">
            <sui-button
              type="button"
              class="comm_btn_gridTop"
              @click="onClickRowAdd"
            >
              {{ $t('MSG_BTN_ROW_ADD') }}
            </sui-button>
            <sui-button
              v-permission:delete="pageId"
              type="button"
              class="comm_btn_gridTop"
              @click="onClickRowDelete"
            >
              {{ $t('MSG_BTN_ROW_DEL') }}
            </sui-button>
            <sui-button
              type="button"
              class="comm_btn_gridTop"
              @click="onClickRowCancel"
            >
              {{ $t('MSG_BTN_CANCEL') }}
            </sui-button>
          </div>
        </sui-grid>
        <div class="comm_btn_wrap">
          <sui-button
            v-permission:update="pageId"
            type="button"
            class="comm_btn_solid"
            @click="onClickSave"
          >
            {{ $t('MSG_BTN_SAVE') }}
          </sui-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00001_T03', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    ruleUid: {
      type: String,
      default: null,
    },
    selectedRowData: {
      type: Object,
      default: null,
    },
    actionMappingList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      inBoundDVOList: [],
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_ACN_NM'),
        datafield: 'actionName',
      }, {
        text: this.$t('MSG_TXT_ACN_TYPE'),
        datafield: 'actionTypeName',
      }, {
        text: this.$t('MSG_TXT_FNC_NM'),
        datafield: 'actionFunctionName',
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'actionUseYnName',
      }],
    };
  },
  computed: {},
  watch: {
    ruleUid() {
      if (!utils.isEmpty(this.selectedRowData)) {
        this.setRuleActionMapping();
      }
    },
    actionMappingList: {
      deep: true,
      handler() {
        this.actionRowAdd();
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (!utils.isEmpty(this.selectedRowData)) {
        this.setRuleActionMapping();
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * 매핑 된 액션 목록 조회
     */
    setRuleActionMapping() {
      http.request(this.pageId, 'DTS_CMR_00009', {
        path: {
          'rule-uid': this.ruleUid,
        },
      }).then(res => {
        this.dsAction.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
      });
    },
    /**
     * 그리드 row 관련 이벤트
     */
    onClickRowAdd() {
      this.$emit('onPopupCall'); // return 시 함수 actionRowAdd() 실행
    },
    onClickRowDelete() {
      const selectedIndexes = this.dsAction.getSelectedIndexes();
      this.dsAction.deleteRows(selectedIndexes);
    },
    onClickRowCancel() {
      this.dsAction.submit(); // 해당 dataset CRUD 정보 리셋
      this.dsAction.setRawData(this.dsAction.originalData);
    },
    /**
     * 그리드 row 추가 팝업 리턴 함수
     */
    actionRowAdd() {
      const actionList = [];
      utils.forEach(this.actionMappingList, value => {
        const index = utils.findIndex(this.dsAction.data, o => utils.isEqual(o.actionUid, value.actionUid));
        if (index < 0) actionList.push(value);
      });
      this.dsAction.addRows(actionList);
    },
    /**
     * 저장
     */
    onClickSave() {
      const dataParams = {
        ruleActionList: this.dsAction.data,
      };

      if (!this.selectedRowCheck()) return false;

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, 'DTS_CMR_00014', {
          path: {
            'rule-uid': this.ruleUid,
          },
          data: dataParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
          this.dsAction.submit(); // 해당 dataset CRUD 정보 리셋
        });
      });

      return true;
    },
    selectedRowCheck() {
      if (utils.isEmpty(utils.trim(this.ruleUid))) {
        utils.messageBox('warning', this.$t('MSG_ALT_RUL_NOT_INFO'));
        return false;
      }
      return true;
    },
  },
  datasets: [{
    id: 'dsAction',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'actionUid', map: 'actionUid' },
      { type: 'string', name: 'actionName', map: 'actionName' },
      { type: 'string', name: 'actionTypeCode', map: 'actionTypeCode' },
      { type: 'string', name: 'actionTypeName', map: 'actionTypeName' },
      { type: 'string', name: 'actionExplanationContent', map: 'actionExplanationContent' },
      { type: 'string', name: 'actionFunctionName', map: 'actionFunctionName' },
      { type: 'string', name: 'actionUseYn', map: 'actionUseYn' },
      { type: 'string', name: 'actionUseYnName', map: 'actionUseYnName' }],
  }],
};
</script>
<style scoped>
</style>
